<style>
	.el-dialog__body {
		padding: 0 20px 20px 20px!important;
	}
	.flex-rows {
		display: flex;
		flex-direction: row;
		align-items: center;
		margin: 10px 0;
	}
	.t-name {
		font-size: 16px;
		width: 60px;
		text-align: left;
	}
	.t-name:before {
		content:'·';
		margin-right: 10px;
	}
	.t-time {
		margin-left: 20px;
		margin-right: 20px;
		width: 180px;
		text-align: center;
	}
	.titles {
		text-align: center;
		font-weight: bold;
		font-size: 18px;
		padding-bottom: 10px;
		margin-bottom: 20px;
		border-bottom: solid 1px #dcdcdc;
	}
	.form-lines {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		margin-bottom: 20px;
	}
	.form-names {
		width: 80px;
		text-align: right;
		margin-right: 10px;
	}
</style>
<template>
	<div>
		<div style="display: flex; flex-direction: row;">
			<div style="margin-right: 50px;">
				<div class='titles'>会员信息编辑</div>
				<div class="form-lines">
					<div class="form-names">上级:</div>
					<el-input size="medium" style="width: 200px;" v-model="info.pid"></el-input>
				</div>
				<div class="form-lines">
					<div class="form-names">UID:</div>
					<el-input size="medium" style="width: 200px;" disabled v-model="info.uid"></el-input>
				</div>
				<div class="form-lines">
					<div class="form-names">账号:</div>
					<el-input size="medium" style="width: 200px;" disabled v-model="info.username"></el-input>
				</div>
				<div class="form-lines">
					<div class="form-names">密码:</div>
					<el-button type="warning" style="width: 200px;" @click="resetPassWord()">重置</el-button>
				</div>
				<div class="form-lines">
					<div class="form-names">昵称:</div>
					<el-input size="medium" style="width: 200px;" v-model="info.nickname"></el-input>
				</div>
				<div class="form-lines">
					<div class="form-names">邀请码:</div>
					<el-input size="medium" style="width: 200px;" v-model="info.inviteCode"></el-input>
				</div>
			</div>
			<div>
				<div>
					<div class='titles'>数据包开通情况</div>
					<div class='flex-rows'>
						<div class='t-name'>体彩</div>
						<div class='t-time'>{{timestampToIntlFormat(info.ticai*1000)}}</div>
						<div class='t-ac'>
							<el-tag type="danger" style="margin-right: 20px;" size="mini" @click="addTime()">加时</el-tag>
							<el-tag type="success" size="mini" @click="subTime()">减时</el-tag>
						</div>
					</div>
					
					<!-- <div class='flex-rows'>
						<div class='t-name'>北单</div>
						<div class='t-time'>{{timestampToIntlFormat(info.peking*1000)}}</div>
						<div class='t-ac'>
							<el-tag type="danger" style="margin-right: 20px;" size="mini">加时</el-tag>
							<el-tag type="success" size="mini">减时</el-tag>
						</div>
					</div>
					
					<div class='flex-rows'>
						<div class='t-name'>福彩</div>
						<div class='t-time'>{{timestampToIntlFormat(info.fucai*1000)}}</div>
						<div class='t-ac'>
							<el-tag type="danger" style="margin-right: 20px;" size="mini">加时</el-tag>
							<el-tag type="success" size="mini">减时</el-tag>
						</div>
					</div> -->
					
					<div class='titles' style="margin-top: 20px;">代理信息</div>
					<div class="form-lines">
						<div class="form-names">代理权限:</div>
						<el-switch :active-value="1" :inactive-value="0"
						  v-model="info.is_agent"
						  active-text="开启"
						  inactive-text="关闭">
						</el-switch>
					</div>
					<div class="form-lines">
						<div class="form-names">客服开关:</div>
						<el-switch :active-value="1" :inactive-value="0"
						  v-model="info.service_state"
						  active-text="开启"
						  inactive-text="关闭">
						</el-switch>
					</div>
					<div class="form-lines">
						<div class="form-names">支付开关:</div>
						<el-switch :active-value="1" :inactive-value="0"
						  v-model="info.pay_state"
						  active-text="开启"
						  inactive-text="关闭">
						</el-switch>
					</div>
					<div class="form-lines">
						<div class="form-names">推广返佣:</div>
						<el-input type="number" size="medium" style="width: 200px;" v-model="info.agent_fee"></el-input>
						<div>&nbsp;‰（千分）</div>
					</div>
					<div class="form-lines">
						<div class="form-names">消费折扣:</div>
						<el-input type="number" size="medium" style="width: 200px;" v-model="info.discount"></el-input>
						<div>&nbsp;‰（千分）</div>
					</div>
					
					<div class='titles' style="margin-top: 20px;">出票服务费</div>
					<div class="form-lines">
						<div class="form-names">出票服务费:</div>
						<el-input type="number" size="medium" style="width: 200px;" v-model="info.ticket_fee"></el-input>
						<div>&nbsp;‰（千分）</div>
					</div>
				</div>
			</div>
		</div>
		<div style="width: 100%; display: flex; flex-direction: row; justify-content: center; padding-top: 20px; border-top: solid 1px red;">
			<el-button type="primary" style="width: 200px;" @click="submitApi">保存</el-button>
		</div>
		
	</div>
</template>

<script>
	export default {
		props:['oldInfo'],
		data(){
			return {
				info:{}
			}
		},
		created() {
			this.info = JSON.parse(JSON.stringify(this.oldInfo))
		},
		methods:{
			addTime(){
				let _this = this;
				this.$prompt('请输入要【增加】的时间（天）', '提示', {
					confirmButtonText: '确定',
				    cancelButtonText: '取消',
				}).then(({ value }) => {
				        console.log(value);
						_this.$api.post("/User/addTimeDate", {uid:_this.info.uid, days:value}).then(res=>{
							if(res.code == 200){
								_this.info.ticai = res.data.ticai;
								_this.$message({ message: '赠送成功', type: 'success', });
							}else{
								_this.$message({ message: '赠送失败', type: 'warning', });
							}
						}).catch(res=>{
							_this.$message({ message: '赠送失败', type: 'warning', });
						});
				}).catch(() => {    
				});
			},
			subTime(){
				let _this = this;
				this.$prompt('请输入要【扣减】的时间（天）', '提示', {
					confirmButtonText: '确定',
				    cancelButtonText: '取消',
				}).then(({ value }) => {
				        console.log(value);
						_this.$api.post("/User/subTimeDate", {uid:_this.info.uid, days:value}).then(res=>{
							if(res.code == 200){
								_this.info.ticai = res.data.ticai;
								_this.$message({ message: '扣减成功', type: 'success', });
							}else{
								_this.$message({ message: '扣减失败', type: 'warning', });
							}
						}).catch(res=>{
							_this.$message({ message: '扣减失败', type: 'warning', });
						});
				}).catch(() => {    
				});
			},
			resetPassWord(){
				let _this = this;
				this.$confirm('是否确认充值密码为 123456 ?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					_this.$api.post("/User/resetPassword", {uid:this.info.uid}).then(res=>{
						if(res.code == 200){
							_this.$message({ message: '重置成功', type: 'success', });
						}else{
							_this.$message({ message: '重置失败', type: 'warning', });
						}
					}).catch(res=>{
						_this.$message({ message: '重置失败', type: 'warning', });
					});
				}).catch(() => {         
				});
			},
			submitApi(){
				let _this = this;
				_this.loading = true;
				_this.$api.post("/User/editUserApi", this.info).then(res=>{
					_this.loading = false;
					if(res.code == 200){
						_this.$message({ message: '编辑成功', type: 'success', });
					}else{
						_this.$message({ message: '编辑失败', type: 'warning', });
					}
				}).catch(res=>{
					_this.loading = false;
				});
			},
			timestampToIntlFormat(timestamp) {
				if(timestamp == 0){
					return '未开通';
				}
			  const formatter = new Intl.DateTimeFormat('default', {
			    year: 'numeric',
			    month: 'long',
			    day: 'numeric',
			    hour: 'numeric',
			    minute: 'numeric'
			  });
			  return formatter.format(new Date(timestamp));
			}
		}
	}
</script>